<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

    import {onMount} from 'svelte';
    import {submit} from '../Form/utils.js';
    import ComboSelect from '../ComboSelect/ComboSelect.svelte';
    import ConfirmationModal from '../ConfirmationModal.svelte';
    import Button from '../Button.svelte';
    import Errors from '../Errors.svelte';
    import {get} from '../../utils.js';
    import {sgettext} from "../../i18n.js"

    export let id = 'competenciesMultiSelect';
    export let actionUrl = `${PATH_PREFIX}/sw/api/elements_database/<element_version_id>/competencies/`;
    export let dataUrl = '';
    export let listUrl = `${PATH_PREFIX}/sw/api/elements_database/<element_version_id>/available-competencies/`;
    export let editable = true;
    export let pill = false;
    export let showLoad = true;
    export let fullOptions = [];

    let showForm = !showLoad;
    let competencies = [];
    let availableCompetencies = [];

    $: fullOptions = availableCompetencies.concat(competencies);
    let competencyOptions = [];

    function handleSave() {
        let allCompetencies = {};
        fullOptions.forEach((e) => {
            allCompetencies[e.id] = e;
        });

        let comps = competencyOptions.map(comp => {
            const comp_id = comp;
            comp = allCompetencies[comp];
            comp = Object.assign({}, comp);
            comp.competency = comp_id;
            comp.id = 'element_competency' in comp ? comp.element_competency : null;
            return comp
        });
        submit(`${actionUrl}`, 'PATCH', [...new Set(comps)]);
    }

    async function getCompetencies() {
        const resp = await get(dataUrl);
        const result = await resp.json();
        competencies = result.results.map((c) => {
            return {
                'id': c.competency,
                'name': c.competency_name,
                'element_competency': c.id
            }
        });
        competencyOptions = competencies.map((e) => e.id);
    }

    async function getAvailableCompetencies() {
        const resp = await get(listUrl);
        availableCompetencies = await resp.json();
    }

    onMount(async () => {
        await getCompetencies();
        await getAvailableCompetencies();
        showForm = true;
    });
</script>


<table class="table">
    <thead class="thead-light">
        <tr>
            <th>
                {sgettext('$$COMPETENCIES$$')}
            </th>
        </tr>
    </thead>
    <tbody>
        {#if showForm}
        <tr>
            <ComboSelect
                {id}
                options={fullOptions}
                multiple={true}
                searchable={true}
                pill={pill}
                bind:value={competencyOptions}
                on:changed={handleSave}
                editable={editable} />
        </tr>
        {:else}
        <tr>
            <div class="d-flex justify-content-center mt-3">
                <div class="spinner-border text-primary text-center">
                </div>
            </div>
        </tr>
        {/if}
    </tbody>
</table>
